const template = `
  <notifier class="alert alert-warning" ng-if="$ctrl.active">
    <notifier-message>UPDATES AVAILABLE</notifier-message>
    <notifier-actions>
      <button type="button" class="btn btn-warning btn-md waves-effect">
        Reload Application
      </button>
    </notifier-actions>
  </notifier>
`;

function controller() {
	const ctrl = this;

	ctrl.active = true;
	ctrl.$onInit = onInit;

	function onInit() {
		// todo
		// - store current api version local
		// - pull on config variable that watches api header
		// watch for changes
	}
}

export default angular
	.module("vesl.componenet.api-updated-notifier", [])
	.component("apiUpdatedNotifier", {
		template,
		controller
	}).name;
